import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './authContext';
import { Box, Typography, Button } from '@mui/material';

const CustomerSelect = () => {
  const { user, shopikUser, customer, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && customer && Object.keys(customer).length > 0) {
      navigate('/dashboard');
    }
  }, [loading, user, customer, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
        textAlign: 'center',
        px: 3,
      }}
    >
      <img src="/images/logo.png" alt="Hemlock" style={{ maxWidth: '160px', marginBottom: 8 }} />
      <Typography variant="h5" sx={{ fontWeight: 500 }}>
        You're a member of another account
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 360 }}>
        You're currently a member of another Hemlock account. Contact the account owner if you need access to their features.
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Want to create your own account?
      </Typography>
      <Button
        variant="contained"
        href="/login"
        sx={{
          backgroundColor: '#4751ed',
          textTransform: 'none',
          ':hover': { backgroundColor: '#6133aa' },
        }}
      >
        Sign Up
      </Button>
    </Box>
  );
};

export default CustomerSelect;
